export default __webpack_public_path__ + "029e79859546001210b1f2b40b518b5b.png";